
import { mapGetters } from 'vuex'

import { SCHEMA_SEARCH_NAME } from '@core/helpers/head'
import { EXPERIMENT_GOOD_DEALS_LINK } from '@navigation/constant'

import translations from './Combobox.translations'
import Listbox from './Listbox.vue'
import Textbox from './Textbox.vue'

export default {
  components: {
    Textbox,
    Listbox,
  },
  props: {
    popularSearches: {
      type: Array,
      default: () => [],
    },
    suggestions: {
      type: Array,
      default: () => [],
    },
    inputId: {
      type: String,
      default: undefined,
    },
  },

  data() {
    return {
      selectedIndex: -1,
      isListboxOpen: false,
      inputValue: '',
    }
  },

  computed: {
    ...mapGetters({
      experiments: 'experiments/getExperiments',
    }),

    // TODO: Clean task https://backmarket.atlassian.net/browse/BRO-2079
    shouldUseNewGoodDealsLink() {
      return this.experiments.goodDealsLink === 'goodDealsEventPage'
    },
    inputName: () => SCHEMA_SEARCH_NAME,
    selection() {
      return {
        query: this.inputValue,
        item: this.items[this.selectedIndex],
        index: this.selectedIndex,
      }
    },

    hasQuery() {
      return this.inputValue !== ''
    },

    title() {
      if (this.inputValue) {
        return ''
      }

      return this.$t(translations.popularSearches)
    },

    items() {
      if (this.inputValue) {
        // TODO: Clean task https://backmarket.atlassian.net/browse/BRO-2079
        return this.suggestions.map((suggestion) => ({
          ...suggestion,
          link: this.shouldReplaceLink(suggestion, 'objectID'),
        }))
      }

      // TODO: Clean task https://backmarket.atlassian.net/browse/BRO-2079
      return this.popularSearches.map((suggestion) => ({
        ...suggestion,
        link: this.shouldReplaceLink(suggestion, 'landingId'),
      }))
    },
  },

  beforeMount() {
    const input = document.querySelector(`#${this.inputId}`)
    if (input) {
      this.changeHandler(input.value)
    }
  },

  methods: {
    // TODO: Clean task https://backmarket.atlassian.net/browse/BRO-2079
    // linkObject: Object with the route object and information about link
    // identifiedBy: The attribute where we will identify the link to replace
    shouldReplaceLink(linkObject, identifiedBy) {
      const linkIdIsInTheListToBeReplaced =
        this.$config.TOP_SALES_BONS_PLANS_LINK_ID?.includes(
          linkObject[identifiedBy],
        )

      if (linkIdIsInTheListToBeReplaced && this.shouldUseNewGoodDealsLink) {
        return EXPERIMENT_GOOD_DEALS_LINK
      }

      return linkObject.link
    },

    submitHandler() {
      this.submit()
    },

    changeHandler(value) {
      this.inputValue = value
      this.selectedIndex = -1
      this.$emit('change', this.inputValue)
    },

    selectIndex(index) {
      this.selectedIndex = index
      this.submit()
    },

    changeSelectedIndex(offset) {
      const { length } = this.items
      if (length !== 0) {
        this.selectedIndex = (length + this.selectedIndex + offset) % length
      }
    },

    closeListbox() {
      this.isListboxOpen = false
    },

    openListbox() {
      this.selectedIndex = -1
      this.isListboxOpen = true
    },

    submit() {
      this.$refs.textbox.blur()
      this.$emit('submit', this.selection)
    },
  },
}
